import { combineReducers } from "redux";
import { DESTROY_SESSION } from "../actions/type";
import auth from "./auth";
import notification from "./notification";
import chat from "./chat";
import inquiry from "./inquiry";
import order from "./order";
import vendorProduct from "./vendorProduct";
import vendorDashboard from "./vendorDashboard";

const appReducer = combineReducers({
  auth,
  notification,
  chat,
  inquiry,
  order,
  vendorProduct,
  vendorDashboard,
});

const rootReducer = (state, action) => {
  // // Clear all data in redux store to initial.
  if (action.type === DESTROY_SESSION) {
    state = undefined;
    action = { type: "@@INIT" };
  }
  return appReducer(state, action);
};
export default rootReducer;
